const splitRemark = (remark) => {
  // Sanitize the input to remove newline characters
  const sanitizedRemark = remark.replace(/\n/g, "").trim();
  // Regex to extract parts
  const regex = /^(.*?) \(By (.*?) at (.*)\)$/;
  const matches = sanitizedRemark.match(regex);

  if (matches) {
    return {
      firstPart: matches[1],
      secondPart: matches[2],
      thirdPart: matches[3],
    };
  }
  return null; // Return null if no match
};

const RemarkList = ({ remarkList, OpenRemarkList }) => {
  return (
    <>
      {OpenRemarkList && remarkList && (
        <div className={`px-4 pb-4 ${remarkList.length > 2 ? "h-40" : ""}`}>
          <table
            className={`remark-table ${remarkList.length > 2 ? "h-full" : ""}`}
          >
            <thead
              className={`remark-thead ${
                remarkList.length > 2 ? "w-99%" : "w-full"
              }`}
            >
              <th className="remarkTd">User</th>
              <th className="remarkTd">Description</th>
              <th className="remarkTd">Date</th>
            </thead>
            <tbody className="remark-tbody">
              {remarkList.map((remark, ind) => {
                const parts = splitRemark(remark);
                return (
                  <tr key={ind} className="remark-tr">
                    <td className="remarkTd">{parts?.secondPart || "N/A"}</td>
                    <td className="remarkTd">{parts?.firstPart || "N/A"}</td>
                    <td className="remarkTd">{parts?.thirdPart || "N/A"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};
export default RemarkList;
